import { NeonMode, NeonModeUtils } from '@arcual/lib-app-neon';
import { defineStore } from 'pinia';
import { readonly, ref } from 'vue';

export const useModeStore = defineStore('modeStore', () => {
  const defaultMode = NeonModeUtils.getMode() || NeonMode.Light;

  const mode = ref(defaultMode);

  const getMode = () => readonly(mode);

  const setMode = (newMode: NeonMode) => {
    mode.value = newMode;
    localStorage.setItem('mode', newMode);
    NeonModeUtils.switchMode(newMode);
  };

  const init = () => {
    const _mode = (localStorage.getItem('mode') as NeonMode) || NeonMode.Light;
    NeonModeUtils.init(_mode);
    setMode(_mode);
  };

  /**
   * Reset the store to its initial state using the value from NeonModeUtils
   */
  const reset = () => {
    setMode(defaultMode);
  };

  return {
    getMode,
    setMode,
    init,
    reset,
  };
});
